import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'update-company-data.confirmation-modal.header',
    defaultMessage: 'Confirm company data update',
  },
  firstParagraph: {
    id: 'update-company-data.confirmation-modal.first-paragraph',
    defaultMessage: 'Submitting the updated information will also change your Stripe customer billing address.',
  },
  secondParagraph: {
    id: 'update-company-data.confirmation-modal.second-paragraph',
    defaultMessage: 'Please make sure that you have entered correct information.',
  },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  submit: { id: 'actions.submit', defaultMessage: 'Submit' },
});

const UpdateCompanyDataConfirmationDialog = ({ confirmationModalVisible, hide }) => {
  const { formatMessage } = useIntl();

  const header = <div className="dashboard-panel-header">{formatMessage(messages.header)}</div>;

  return (
    <Dialog visible={confirmationModalVisible} onHide={hide} header={header} modal>
      <p>{formatMessage(messages.firstParagraph)}</p>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <div className="mt20 flex-center">
        <Button type="button" className="p-button-secondary" label={formatMessage(messages.cancel)} onClick={hide} />
        <Button type="submit" className="p-button-primary" label={formatMessage(messages.submit)} />
      </div>
    </Dialog>
  );
};

export default UpdateCompanyDataConfirmationDialog;
